import { Card } from 'components/Card'
import { FooterRoot } from 'components/Footer/Footer.styles'
import { styled } from 'stitches.config'

export const MealPlanRoot = styled('div', {
  '&': {
    [`${FooterRoot}`]: {
      borderTop: '12px solid transparent',
      borderBottom: 0,
      borderImage: 'url(/assets/pattern-footer-border-mobile.svg) 30',

      '@bp2': {
        borderImage: 'url(/assets/pattern-footer-border-desktop.svg) 30',
      },
    },
  },
})

export const ContentWrapper = styled('div', {
  backgroundColor: '$secondary-100',
})

export const MaxSize = styled('div', {
  maxWidth: '$max',
  margin: 'auto',
  variant: {
    width: {
      full: {
        maxWidth: '100%',
      },
    },
  },
})

export const MealPlanQuestionnaireCard = styled(Card, {
  borderTopRightRadius: '0px',
  borderTopLeftRadius: '0px',
  borderTop: 'none',
  padding: '$3',
  paddingBottom: '$4',

  '@bp2': {
    px: '$10',
    py: '$7',
  },
})
